import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { GraphDataPoint } from '../types'
import { calculateVariableBorrowRateByUtilization } from '@/features/sparklend/common/data/market-info/math'

export interface InterestRateChartArgs {
  optimalUtilizationRate: Percentage
  variableRateSlope1: BigNumber
  variableRateSlope2: BigNumber
  baseVariableBorrowRate: BigNumber
  totalLiquidity: NormalizedNumber
  totalDebt: NormalizedNumber
}
export function getRates({
  optimalUtilizationRate,
  variableRateSlope1,
  variableRateSlope2,
  baseVariableBorrowRate,
  totalLiquidity,
  totalDebt,
}: InterestRateChartArgs): GraphDataPoint[] {
  const resolution = 200
  const step = 1 / resolution

  const yields: GraphDataPoint[] = []

  for (let i = 0; i <= resolution; i++) {
    const utilization = Percentage(i * step)

    const rate = calculateVariableBorrowRateByUtilization({
      optimalUtilizationRate,
      utilization,
      variableRateSlope1,
      variableRateSlope2,
      baseVariableBorrowRate,
    })

    const utilizationDelta = totalLiquidity.times(utilization).minus(totalDebt)

    yields.push({
      x: utilization.toNumber(),
      y: rate.toNumber(),
      utilizationDelta,
    })
  }

  return yields
}
